<div class="user-profile-container" *ngIf="this._authSvc.user$| async as user">
  <div class="flex-row-container items-center p-12 gap-16">
    <img class="avatar-img sq-48" mat-card-avatar [src]="user.picture" />
    <div class="flex-col-container">
      <p class="fs-20 fw-500">{{user.name}}</p>
      <span class="fs-12 break-all text-gray">{{user['user_roles']?.join(', ')}}</span>
      <span class="fs-12 break-all">{{user.email}}</span>
    </div>
    <!-- <div class="mt-4">
      <a href="https://www.google.com/" target="_blank">View scopes</a>
    </div> -->
    <!-- FIXME delete. only for testing -->
    <!-- <div *ngFor="let item of this._usrCtxSvc.getScopes()">{{item}}</div> -->
  </div>
</div>
